import { CSSProperties } from "react";
import classNames from "classnames";
import FaIcon from "../../utils/fa_icon";
import { SwitchableApp } from "./app-switch.types";
import styles from "./app-switch.module.scss";


export default function AppTile({
  app,
  className,
  style,
}: {
  app: SwitchableApp;
  className?: string;
  style?: CSSProperties;
}) {
  return (
    <span
      className={classNames(className, { [styles.tile_logo]: !!app.logo })}
      style={style}
    >
      {app.logo ? (
        <img src={app.logo} alt="" className={styles.tile_img} draggable="false" />
      ) : app.icon ? (
        <FaIcon icon={app.icon} />
      ) : (
        <span className={styles.app_initial}>{app.title?.charAt(0)}</span>
      )}
    </span>
  );
}

export { AppTile };
